import { Point, Stitch, AlignmentSettings } from '../types/pattern';

export const validSectors = [2, 3, 4, 5, 6, 8, 9, 10, 12, 15, 18, 20, 24, 30, 36, 40, 45, 60, 72];

export const calculateAngle = (point: Point, center: Point): number => {
  return Math.atan2(point.y - center.y, point.x - center.x);
};

export const calculateDistance = (point: Point, center: Point): number => {
  return Math.sqrt(Math.pow(point.x - center.x, 2) + Math.pow(point.y - center.y, 2));
};

export const alignStitch = (
  stitch: Stitch,
  orientationCenter: Point
): Stitch => {
  const dx = orientationCenter.x - stitch.position.x;
  const dy = orientationCenter.y - stitch.position.y;
  const angle = Math.atan2(dy, dx) - Math.PI / 2;
  return { ...stitch, angle, orientationAngle: angle };
};

export const drawAlignmentGuides = (
  ctx: CanvasRenderingContext2D,
  center: Point,
  radius: number,
  settings: AlignmentSettings
): void => {
  if (!settings.showGuides) return;
  
  ctx.save();
  ctx.strokeStyle = '#ccc';
  ctx.lineWidth = 0.5;
  
  // Calculate max circle radius
  const maxRadius = settings.circleStep * settings.circlesCount;
  
  // Draw radial lines
  const angleStep = (Math.PI / 180) * settings.radialAngleStep;
  for (let angle = 0; angle < 2 * Math.PI; angle += angleStep) {
    ctx.beginPath();
    ctx.moveTo(center.x, center.y);
    ctx.lineTo(
      center.x + maxRadius * Math.cos(angle),
      center.y + maxRadius * Math.sin(angle)
    );
    ctx.stroke();
  }
  
  // Draw concentric circles
  for (let r = settings.circleStep; r <= maxRadius; r += settings.circleStep) {
    ctx.beginPath();
    ctx.arc(center.x, center.y, r, 0, 2 * Math.PI);
    ctx.stroke();
  }
  
  ctx.restore();
};

export const drawSymmetryAxes = (
  ctx: CanvasRenderingContext2D,
  center: Point,
  radius: number,
  symmetryAxes: number
): void => {
  if (symmetryAxes < 2) return;

  ctx.save();
  ctx.strokeStyle = 'rgba(25, 118, 210, 0.4)';
  ctx.lineWidth = 1.5;
  ctx.setLineDash([6, 4]);

  const step = (2 * Math.PI) / symmetryAxes;
  for (let i = 0; i < symmetryAxes; i++) {
    const angle = step * i;
    ctx.beginPath();
    ctx.moveTo(center.x, center.y);
    ctx.lineTo(center.x + radius * Math.cos(angle), center.y + radius * Math.sin(angle));
    ctx.stroke();
  }

  ctx.restore();
}; 